export default __webpack_public_path__ + "static/media/domains-are-nfts.32a88a65.svg";